import React,{useEffect} from "react";
import { useNavigate } from "react-router-dom";

function ThankYou() {
  const navigate = useNavigate();
  const handleGoBack = () => {
    console.log("handle back");
    navigate(`/`);
  };

  useEffect(() => {
    console.log("event logged")
    window.gtag("event", "conversion", {
      send_to: "AW-10917910622/K7ykCJKEycMDEN6wiNYo",
  });
  window.gtag('event', 'conversion', {'send_to': 'AW-10917910622/pC5KCPms4tkZEN6wiNYo'});
  window.gtag('event', 'conversion', {'send_to': 'AW-10917910622/QuEYCPys4tkZEN6wiNYo'});
    window.gtag('js', new Date());
    window.gtag('config', 'AW-10917910622');
    // window.fbq('init', '{1584375811875352}');
    // window.fbq("track","PO-Thank-You");
    // window.fbq('init', '{1584375811875352}');
    // window.fbq("track","PO-Thank-You-All");
    window.fbq('init', '{1584375811875352}');
    window.fbq("track","HR-Aspire-TY-EL");
  
  },[]);

  return (
    <>   
      <section className="thankyou">
      <div className="container">
        <div className="row">
          <div className="col-md-6 order-md-2">
           <div className="content">
            <h4>Thank you.</h4>
            <p>We have received your application for the ICICI Bank Probationary Officer Program</p>
            <p>Basis your eligibility, you will receive an email and/or WhatsApp from ‘ICICI Careers’ with a link to appear for an ‘Online Test’.</p>
            <p>Kindly ensure you check your email and/or WhatsApp regularly for the next few days.</p>
           </div>
          </div>
          <div className="col-md-6 order-md-1">
            <div className="successfulimg"></div>
          </div>
        </div>

      </div>
       
    </section>
    </>
  );
}

export default ThankYou;
